import * as React from 'react'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import CardCtaImage from 'components/atomic/molecules/card-cta-image'

const CTACommunity = () => {
    const { t }: I18n = useTranslation()

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }

    return (
        <CardCtaImage
            title={t('path:communitySection.ctaTitle')}
            description={t('path:communitySection.ctaDescription')}
            buttonText={t('path:communitySection.buttonText')}
            image="/assets/community-cta.png"
            onClick={handleClick}
        />
    )
}

export default CTACommunity
